module.exports = __webpack_public_path__ + "static/img/flag-en.05a4a902.svg";